import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';

import { File } from 'modules/common';

import { queryKeys } from '../constants';

export const useJobAllFiles = (props?: { enabled?: boolean; page?: number }) =>
  useQuery<Pagination<File>>({
    queryKey: [queryKeys.JOB_ALL_FILES, props],
    queryFn: async () => {
      const res = await $api.post('/v1/job/all-files', {
        page: props?.page,
        size: 15
      });

      const data: Pagination<File> = res?.data?.data;

      return data
        ? {
            ...data,
            data: data?.data?.map(item => ({
              ...item,
              createdDate: timeStampToDate({
                date: item?.createdDate,
                timeStamp: item?.createdTimestamp
              })
            }))
          }
        : data;
    },
    enabled: props?.enabled
  });
